import { createContext, useContext, type ReactNode } from 'react';

interface ModalContextType {
  openLoginModal: () => void;
  openCreateSquadModal: () => void;
  openJoinSquadModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

interface ModalProviderProps {
  children: ReactNode;
  openLoginModal: () => void;
  openCreateSquadModal: () => void;
  openJoinSquadModal: () => void;
}

export function ModalProvider({
  children,
  openLoginModal,
  openCreateSquadModal,
  openJoinSquadModal,
}: ModalProviderProps) {
  return (
    <ModalContext.Provider
      value={{
        openLoginModal,
        openCreateSquadModal,
        openJoinSquadModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
}

export function useModal() {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
}

